/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CartonGradeCatalogImportLogDTO,
  ErrorResponse,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class CartonGradeImportApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags carton-grade-import-api
   * @name GetImportLog
   * @request GET:/api/carton-grades-import-log
   * @secure
   */
  getImportLog = (params: RequestParams = {}) =>
    this.request<CartonGradeCatalogImportLogDTO[], ErrorResponse>({
      path: `/api/carton-grades-import-log`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags carton-grade-import-api
   * @name ImportCatalog
   * @request POST:/api/carton-grades-import-log
   * @secure
   */
  importCatalog = (params: RequestParams = {}) =>
    this.request<CartonGradeCatalogImportLogDTO, ErrorResponse>({
      path: `/api/carton-grades-import-log`,
      method: "POST",
      secure: true,
      ...params,
    });
}
